<template>
  <button
    class="w-max items-center rounded-full bg-white px-6 py-4 text-base font-semibold text-black shadow-lg transition"
    @click="$emit('toggle')"
  >
    <slot />
  </button>
</template>
